/*
  Authored by Brett Barinaga on 11/17/21.
  Copyright (c) Kochava, Inc. All rights reserved.
*/
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as http from "../http";
import * as utils from "../utils/utils";
import * as browser from "../browser/browser";
import { Log } from "../utils/log";
import { constructCommonData } from "./payload";
export var constructPreStart = function (instance, eventName, eventData) {
    var preStart = {
        action: "event",
        sdk_version: instance.version,
        sdk_protocol: "17",
        data: {
            event_name: eventName,
            event_data: eventData,
            device_orientation: browser.getDeviceOrientation(),
            disp_w: browser.getDeviceWidth(),
            disp_h: browser.getDeviceHeight(),
        },
    };
    if (instance.kochavaConfig)
        preStart.init_token = (instance.kochavaConfig.config.init_token) || undefined;
    return preStart;
};
export var constructPostStart = function (instance, preStartBody) {
    var postStartBody = {
        kochava_app_id: instance.appGuid,
        kochava_device_id: instance.kochavaDeviceId,
        nt_id: "".concat(instance.kochavaSession, "-").concat(instance.kochavaSessionCount, "-").concat(utils.uuidv4()),
    };
    postStartBody.data = __assign(__assign({}, constructCommonData(instance)), preStartBody.data);
    instance.customValues.forEach(function (custom) {
        if (!custom.isDeviceId) {
            var customKey = Object.keys(custom.data)[0];
            if (instance.kochavaConfig.privacy) {
                var keyAllowed = false;
                for (var _i = 0, _a = instance.kochavaConfig.privacy.allow_custom_ids; _i < _a.length; _i++) {
                    var allowed = _a[_i];
                    if (customKey === allowed) {
                        keyAllowed = true;
                    }
                }
                if (keyAllowed)
                    postStartBody.data = __assign(__assign({}, custom.data), postStartBody.data);
            }
        }
    });
    return postStartBody;
};
var build = function (instance, preStartBody, postStartBody) {
    var payload = __assign(__assign({}, preStartBody), postStartBody);
    Log.debug("Event Payload", JSON.stringify(payload));
    if (instance.kochavaConfig.privacy) {
        instance.kochavaConfig.privacy.deny_datapoints.forEach(function (denyPoint) {
            for (var point in payload.data) {
                var key = point;
                if (key === denyPoint)
                    delete payload.data[key];
            }
            for (var point in payload) {
                var key = point;
                if (key === denyPoint)
                    delete payload[key];
            }
        });
    }
    return payload;
};
export var send = function (instance, preStartBody, postStartBody) { return __awaiter(void 0, void 0, void 0, function () {
    var payload, respStr, resp, success;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = build(instance, preStartBody, postStartBody);
                return [4 /*yield*/, http.sendRequest(payload, (instance.overrideUrls.event) ?
                        instance.overrideUrls.event : instance.kochavaConfig.networking.urls.event)];
            case 1:
                respStr = _a.sent();
                success = false;
                try {
                    Log.trace("Event Response string:", respStr);
                    resp = JSON.parse(respStr);
                    Log.debug("Event Response:", respStr);
                    success = http.wasRespSuccess(resp.success);
                }
                catch (e) {
                    Log.error("Error parsing Event Response", e);
                    success = false;
                }
                if (success) {
                    Log.info("Event success!");
                    return [2 /*return*/, true];
                }
                Log.error("Event failed!");
                return [2 /*return*/, false];
        }
    });
}); };
